<div class="flex flex-col items-center justify-center h-screen">
    <p-toast></p-toast>
    
    <div class="flex flex-col items-center justify-center border border-gray-200 rounded-lg p-2 md:p-10 lg:min-w-[450px] border-gray-200 mx-5 md:mx-0">
        <img src="assets/logo.png" alt="Office Global Logo" class=" h-[60px] object-contain">
            
        <h1 class="text-2xl font-bold mt-2">
            {{ isLoginVerification ? 'Login Verification' : 'Email Verification' }}
        </h1>
        <p class="text-base text-gray-500 my-2">
            {{ isLoginVerification ? 'We have sent a verification code to your email address to complete your login' : 'We have sent a verification code to your email address' }}
        </p>

        <p class="text-sm text-gray-500 my-2 border border-gray-200 bg-gray-200 rounded-full p-2 mb-8">{{ maskedEmail }}</p>

        <div class="flex flex-col items-center mb-20">
            <div class="otp-container mb-10">
                <div class="otp-inputs">
                    <input 
                        #otpInput0
                        type="text" 
                        maxlength="1" 
                        [(ngModel)]="otpDigits[0]" 
                        (input)="onOtpInput($event, 0)"
                        (keydown)="onOtpKeydown($event, 0)"
                        (click)="onOtpClick(0)"
                        (paste)="onOtpPaste($event)"
                        class="custom-otp-input"
                        [class.active]="0 === activeIndex"
                        (focus)="setActiveIndex(0)"
                        autocomplete="one-time-code"
                    />
                    <input 
                        #otpInput1
                        type="text" 
                        maxlength="1" 
                        [(ngModel)]="otpDigits[1]" 
                        (input)="onOtpInput($event, 1)"
                        (keydown)="onOtpKeydown($event, 1)"
                        (click)="onOtpClick(1)"
                        (paste)="onOtpPaste($event)"
                        class="custom-otp-input"
                        [class.active]="1 === activeIndex"
                        (focus)="setActiveIndex(1)"
                        autocomplete="one-time-code"
                    />
                    <input 
                        #otpInput2
                        type="text" 
                        maxlength="1" 
                        [(ngModel)]="otpDigits[2]" 
                        (input)="onOtpInput($event, 2)"
                        (keydown)="onOtpKeydown($event, 2)"
                        (click)="onOtpClick(2)"
                        (paste)="onOtpPaste($event)"
                        class="custom-otp-input"
                        [class.active]="2 === activeIndex"
                        (focus)="setActiveIndex(2)"
                        autocomplete="one-time-code"
                    />
                    <input 
                        #otpInput3
                        type="text" 
                        maxlength="1" 
                        [(ngModel)]="otpDigits[3]" 
                        (input)="onOtpInput($event, 3)"
                        (keydown)="onOtpKeydown($event, 3)"
                        (click)="onOtpClick(3)"
                        (paste)="onOtpPaste($event)"
                        class="custom-otp-input"
                        [class.active]="3 === activeIndex"
                        (focus)="setActiveIndex(3)"
                        autocomplete="one-time-code"
                    />
                    <input 
                        #otpInput4
                        type="text" 
                        maxlength="1" 
                        [(ngModel)]="otpDigits[4]" 
                        (input)="onOtpInput($event, 4)"
                        (keydown)="onOtpKeydown($event, 4)"
                        (click)="onOtpClick(4)"
                        (paste)="onOtpPaste($event)"
                        class="custom-otp-input"
                        [class.active]="4 === activeIndex"
                        (focus)="setActiveIndex(4)"
                        autocomplete="one-time-code"
                    />
                    <input 
                        #otpInput5
                        type="text" 
                        maxlength="1" 
                        [(ngModel)]="otpDigits[5]" 
                        (input)="onOtpInput($event, 5)"
                        (keydown)="onOtpKeydown($event, 5)"
                        (click)="onOtpClick(5)"
                        (paste)="onOtpPaste($event)"
                        class="custom-otp-input"
                        [class.active]="5 === activeIndex"
                        (focus)="setActiveIndex(5)"
                        autocomplete="one-time-code"
                    />
                </div>
            </div>
        </div>
        <p-button 
            [label]="isLoginVerification ? 'Complete Login' : 'Verify Email'" 
            class="w-full !w-full mb-4" 
            type="submit" 
            (click)="onVerifyOTP()" 
            [loading]="loading" 
            [disabled]="value.length !== 6">
        </p-button>
        
        <div class="w-full flex flex-col gap-2">
            <button 
                type="button" 
                class="text-blue-600 hover:text-blue-800 text-sm cursor-pointer flex items-center justify-center gap-2 " 
                (click)="onResendOTP()" 
                [disabled]="resendLoading">
                <i *ngIf="resendLoading" class="pi pi-spinner animate-spin"></i>
                {{ resendLoading ? 'Sending...' : (isLoginVerification ? 'Try Again' : 'Resend Code') }}
            </button>
            <button type="button" class="text-gray-600 hover:text-gray-800 text-sm cursor-pointer" (click)="onBackToLogin()">
                Back to Login
            </button>
        </div>
    </div>
</div>